<div class="hidden sm:flex">
  @for (recordToolbarMode of modes; track recordToolbarMode) {
    <button
      (click)="changeViewMode.emit(recordToolbarMode.mode)"
      mat-icon-button
      >
      <fa-icon [class.text-primary]="activeViewMode === recordToolbarMode.mode" [icon]="recordToolbarMode.icon"></fa-icon>
    </button>
  }
</div>

<button [matMenuTriggerFor]="toolbarMenu" class="block sm:hidden" mat-icon-button>
  <fa-icon [icon]="menuIcon"></fa-icon>
</button>

<mat-menu #toolbarMenu="matMenu">
  @for (recordToolbarMode of modes; track recordToolbarMode) {
    <button (click)="changeViewMode.emit(recordToolbarMode.mode)" mat-menu-item>
      <fa-icon
        [icon]="recordToolbarMode.icon"
        [ngClass]="[activeViewMode === recordToolbarMode.mode ? 'text-primary' : '']"
      ></fa-icon>
    </button>
  }
</mat-menu>
